import React, { useState } from "react";
import { Button } from "primereact/button";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import accountService from "../../services/account/account.service";
import { ResetPasswordDto } from "../../services/account/account.dto";
import { InputText } from "primereact/inputtext";
import { useToast } from "../../utils/toast";

const ResetPassword = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();
  const { uid, token } = useParams<{ uid: string; token: string }>();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: ""
    },
    validate: (data) => {
      const errors: any = {};
      if (!data.password) {
        errors.password = "Şifre gereklidir";
      }
      if (!data.confirmPassword) {
        errors.confirmPassword = "Şifre onayı gereklidir";
      }
      if (data.password !== data.confirmPassword) {
        errors.confirmPassword = "Şifreler uyuşmuyor.";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const resetPasswordDto: ResetPasswordDto = {
          uid: uid!,
          token: token!,
          password: values.password
        };
        const response = await accountService.ResetPassword(resetPasswordDto);
        if (response.result && !response.result.error) {
          toast.show("Şifre başarıyla güncellendi.", "success");
          navigate("/loginsebis", { replace: true });
        } else {
          toast.show(response?.result?.error || "Bir hata oluştu", "error");
        }
      } catch (error) {
        toast.show("Bir hata oluştu", "error");
      }
    }
  });

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <div
          className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6 w-full"
          style={{ maxWidth: "460px" }}
        >
          <div className="text-center mb-5">
            <Link to="/">
              <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-3" />
            </Link>
            <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">Şifre Sıfırlama</div>
            <span className="text-600 text-sm">Yeni şifrenizi giriniz</span>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <label htmlFor="password" className="block text-900 font-medium mb-2">
                Şifre
              </label>
              <div className="relative w-full">
                <InputText
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={formik.values.password}
                  onChange={(e) => formik.setFieldValue("password", e.target.value)}
                  placeholder="Şifrenizi giriniz"
                  className="w-full p-3 pr-6"
                />
                <i
                  className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"} cursor-pointer text-600 hover:text-900 absolute`}
                  style={{ right: "1rem", top: "50%", transform: "translateY(-50%)", fontSize: "1.2rem", zIndex: 10 }}
                  onClick={() => setShowPassword(!showPassword)}
                />
                {formik.errors.password && <div className="p-error mt-2 text-sm">{formik.errors.password}</div>}
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="confirmPassword" className="block text-900 font-medium mb-2">
                Şifre Onayla
              </label>
              <div className="relative w-full">
                <InputText
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={formik.values.confirmPassword}
                  onChange={(e) => formik.setFieldValue("confirmPassword", e.target.value)}
                  placeholder="Şifrenizi tekrar giriniz"
                  className="w-full p-3 pr-6"
                />
                <i
                  className={`pi ${showConfirmPassword ? "pi-eye-slash" : "pi-eye"} cursor-pointer text-600 hover:text-900 absolute`}
                  style={{ right: "1rem", top: "50%", transform: "translateY(-50%)", fontSize: "1.2rem", zIndex: 10 }}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
                {formik.errors.confirmPassword && (
                  <div className="p-error mt-2 text-sm">{formik.errors.confirmPassword}</div>
                )}
              </div>
            </div>

            <Button
              type="submit"
              label={loading ? "Yükleniyor..." : "Şifreyi Sıfırla"}
              className="w-full p-3 text-base font-semibold mt-3"
              disabled={loading}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
